import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import BalancosPatrimoniais from '../../components/balanco/listar/patrimonial';


function BalancoPatrimonialScreen () {
    return (
        <Fragment>
            <Head titulo="Balanços Patrimoniais do Município de Macuco"/>
            <Header />
            <Container>
                <BalancosPatrimoniais />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default BalancoPatrimonialScreen;